import axios from 'axios';
import { OwnerType } from 'types/shared/owner-type.enum';
import { ProfileType } from 'types/shared/profile-type.enum';
import { UpdateProfileInput } from '../types/update-profile-input.type';
import { MarketId } from 'types/market-id.enum';

// POST
// /ewosapi/v2/planandprognosis/profile/{profileType}/{type}/{marketId}
export const postProfileByType = async (
  profileType: ProfileType,
  ownerType: OwnerType,
  id: MarketId | string,
  request: UpdateProfileInput
): Promise<number> => {
  const res = await axios.post<number>(`/ewosapi/v2/planandprognosis/profile/${profileType}/${ownerType}/${id}`, request);
  return res.data;
};
